
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToSection = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash in the URL
    if (hash) {
      // Remove the '#' character
      const targetId = hash.replace('#', '');
      
      // Find the element with that id
      const element = document.getElementById(targetId);
      
      // If the element exists, scroll to it
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // If navigating to a new page without hash, scroll to top
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
};
